import React, { useCallback, useState } from 'react';
import { projects } from '../mock';
import Reveal from './Reveal';
import ProjectCard from './ProjectCard';
import Lightbox from './Lightbox';

const Projects = () => {
  const [open, setOpen] = useState(null); // { project, startIdx }

  const handleOpen = useCallback((project, startIdx) => {
    setOpen({ project, startIdx });
  }, []);
  const handleClose = useCallback(() => setOpen(null), []);

  return (
    <section id="projects" className="relative py-24 md:py-36 bg-[#0f0d0b] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <span className="section-num text-sm text-[#B8935A]">04 &mdash; Selected Projects</span>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] max-w-xl">
                Where our stone
                <br />
                <span className="italic text-[#F1EBE1]">now lives.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={150}>
            <p className="max-w-md text-white/70 text-[15px] leading-relaxed">
              Curated portfolio across Singapore.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {projects.map((p, i) => (
            <Reveal key={p.title} delay={(i % 3) * 90}>
              <ProjectCard project={p} onOpen={handleOpen} />
            </Reveal>
          ))}
        </div>
      </div>

      {open && (
        <Lightbox project={open.project} startIdx={open.startIdx} onClose={handleClose} />
      )}
    </section>
  );
};

export default Projects;
